var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "사용자매뉴얼 목록",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          rowKey: "userManualId",
          gridHeight: _vm.height,
          columnSetting: false,
          usePaging: false,
          isExcelDown: false,
        },
        on: { linkClick: _vm.linkClick },
        scopedSlots: _vm._u([
          {
            key: "table-button",
            fn: function () {
              return [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable && !_vm.popupParam.isPopup
                      ? _c("c-btn", {
                          attrs: { label: "등록", icon: "add" },
                          on: { btnClicked: _vm.linkClick },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "customArea",
            fn: function ({ props }) {
              return [
                _c("q-icon", {
                  staticClass: "cursor-pointer",
                  attrs: { name: "description", size: "sm", color: "blue-6" },
                  on: {
                    click: function ($event) {
                      return _vm.iconClick(props.row)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }